import {user, request} from 'lib'


import find from 'lodash/find';
import assign from 'lodash/assign';
import forEach from "lodash/forEach";
import map from "lodash/map";
import uniqBy from "lodash/uniqBy";
import {toJS} from "mobx";

import {store} from './store/bag'
import gift from './gift'


let giftList = []

const init = async () => {
  if (!user.isLogin()) {
    return;
  }
  let res = await request.api.get('user/bag_info_v2/{access_token}');
  if (res) {
    giftList = map(res.data.bag, (count, giftId) => {
      let days = res.data.valid_bag[giftId] || 0;
      let info = gift.getGift(parseInt(giftId, 10))
      return assign({isBag: true}, info, {count, days});
    })
      .filter(item => item.count > 0 && item.id)
      .sort((a, b) => a.coin_price - b.coin_price)


    store.update(giftList)
  }
}


const send = () => {

}


export default {
  init
}

